import { render, staticRenderFns } from "./AddPoints.vue?vue&type=template&id=0d7ac5dc&scoped=true&"
import script from "./AddPoints.vue?vue&type=script&lang=ts&"
export * from "./AddPoints.vue?vue&type=script&lang=ts&"
import style0 from "./AddPoints.vue?vue&type=style&index=0&id=0d7ac5dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ac5dc",
  null
  
)

export default component.exports